import { useEffect, useRef, useState } from 'react';
import Section from '../ui/Section';
import styles from './Contact.module.css';

const FORM_ENDPOINT = 'https://formspree.io/f/xljeqpqv';
const TURNSTILE_SITE_KEY = '0x4AAAAAAE0ZyzxsgHPlF0a_';

const INQUIRY_OPTIONS = [
  'Book Brian Dawson for an event',
  'Discuss a partnership/sponsor opportunity',
  'Other inquiries'
];

export default function Contact() {
  const [status, setStatus] = useState('idle');
  const widgetRef = useRef(null);

  useEffect(() => {
    const render = () => {
      if (window.turnstile && widgetRef.current && !widgetRef.current.dataset.rendered) {
        widgetRef.current.dataset.rendered = 'true';
        window.turnstile.render(widgetRef.current, {
          sitekey: TURNSTILE_SITE_KEY,
          theme: 'dark'
        });
      }
    };
    render();
    const timer = setInterval(() => {
      if (window.turnstile) {
        render();
        clearInterval(timer);
      }
    }, 200);
    return () => clearInterval(timer);
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch(FORM_ENDPOINT, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(e.target)
      });
      if (!res.ok) throw new Error('Request failed');
      setStatus('sent');
      e.target.reset();
    } catch {
      setStatus('error');
    }
  }

  return (
    <Section id="contact" eyebrow="Get in touch" title="Work with Brian Dawson.">
      <p>
        Interested in working with Brian Dawson to further your brand or community outreach?
        Looking to book Brian to host or DJ your event? Use the form below to reach out to Team
        Dawson and someone will respond to you shortly.
      </p>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.row}>
          <label className={styles.field}>
            <span className={styles.label}>Name *</span>
            <input type="text" name="name" required className={styles.input} />
          </label>
          <label className={styles.field}>
            <span className={styles.label}>Email *</span>
            <input type="email" name="email" required className={styles.input} />
          </label>
        </div>
        <label className={styles.field}>
          <span className={styles.label}>I want to... *</span>
          <select name="inquiry" required defaultValue="" className={styles.input}>
            <option value="" disabled>Select an option</option>
            {INQUIRY_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </label>
        <label className={styles.field}>
          <span className={styles.label}>Message *</span>
          <textarea name="message" required rows={5} className={styles.input} />
        </label>
        <div ref={widgetRef} className={styles.captcha} />
        <button type="submit" className={styles.button} disabled={status === 'sending'}>
          {status === 'sending' ? 'SENDING\u2026' : 'SEND'}
        </button>
        {status === 'sent' && (
          <p className={styles.success}>Thanks — Team Dawson will get back to you shortly.</p>
        )}
        {status === 'error' && (
          <p className={styles.error}>Something went wrong. Please try again.</p>
        )}
        <p className={styles.note}>We will not send spam messages.</p>
      </form>
    </Section>
  );
}
